import axios from "axios";
import { createContext, useEffect, useState } from "react";

export const Cartcontext = createContext()

export default function CartcontextProvider({children}){
    const [cart, setcart] = useState({})

    async function GetLoggedUserCart() {
        try {
          const { data } = await axios.get('https://ecommerce.routemisr.com/api/v1/cart', {
            headers: {
              token: localStorage.getItem('token')
            }
          }
    
          )
        
          setcart(data)
    
        } catch (error) {
          console.log(error)
        }
      }
    
      useEffect(()=>{
        GetLoggedUserCart()
      },[])
    return <Cartcontext.Provider value={{cart,setcart}}>
      {children}
    </Cartcontext.Provider>
}